export const PRODUCT_PICKER_LOADING = 'waitrose/products/PRODUCT_PICKER_LOADING';
export const PRODUCT_PICKER_LOADED = 'waitrose/products/PRODUCT_PICKER_LOADED';
export const PRODUCT_PICKER_FAILED = 'waitrose/products/PRODUCT_PICKER_FAILED';
export const PRODUCT_PICKER_CLEAR = 'waitrose/products/PRODUCT_PICKER_CLEAR';
